export default "__VITE_ASSET__JavNf4Yz__"